import styled from "styled-components";

export const ContentsSection = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
  gap: 12px;

  @media (max-width: 410px) {
    font-size: 1.3rem;
    gap: 10px;
  }
`;

export const BlueText = styled.span`
  color: ${(props) => props.theme.colors.primary};
  font-size: 2.8rem;
  font-weight: 750;
  @media (max-width: 410px) {
    font-size: 2.2rem;
  }
`;

export const TextSize = styled.div`
  font-size: 2.8rem;
  font-weight: 550;
  padding-bottom: 30px;
  @media (max-width: 410px) {
    font-size: 2.2rem;
    padding-bottom: 20px;
  }
`;

export const Textdiv = styled.div`
  display: flex;
  color: ${(props) => props.theme.colors.labelTxt};
  font-size: 1.6rem;
  font-weight: 500;
  padding-bottom: 30px;

  @media (max-width: 410px) {
    font-size: 1.4rem;
  }
`;
export const AlterBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: ${(props) => props.theme.colors.cameraBg};
  border-radius: 8px;
  padding: 18px 6px 12px 21px;
  gap: 9px;
`;
export const AlterText = styled.div`
  color: ${(props) => props.theme.colors.balck};
  font-size: 1.5rem;
  font-weight: 600;

  @media (max-width: 410px) {
    font-size: 1.4rem;
    padding-bottom: 5px;
  }
`;
export const AlterLink = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
  font-size: 1.5rem;
  font-weight: 600;

  color: ${(props) => props.theme.colors.primary};

  @media (max-width: 410px) {
    font-size: 1.4rem;
  }
`;
export const ButtonContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: end;
  padding-bottom: 20px;
`;
